/**
 * Translations for the application
 * 
 * Translation strings can include variables using the {{variableName}} syntax.
 * Example usage with the t function:
 * t('welcomeUser', { name: 'John' }) => 'Welcome, John!'
 * 
 * @type {Object.<string, Object.<string, string>>}
 */
const translations = {
  en: {
    // Common
    welcome: 'Welcome',
    search: 'Search',
    searchPlaceholder: 'Search for seeds, tools, equipment...',
    notifications: 'Notifications',
    settings: 'Settings',
    language: 'Language',
    english: 'English',
    hindi: 'Hindi',
    close: 'Close',
    apply: 'Apply',
    seeAll: 'See all',
    pleaseWait: 'Please Wait...',
    chooseCategory: 'CHOOSE A CATEGORY',
    
    // Livestock Page
    buyLivestock: 'Buy Animals',
    animalFeed: 'Animal Feed',
    livestockInsurance: 'Animal Insurance',
    businessmen:'Traders',
    // Navigation
    home: 'Home',
    feed: 'Agro Media',
    chat: 'Chat',
    socialFeed: 'Social Feed',
    profile: 'Profile',
    viewEditProfile: 'View/Edit Profile',
    myProducts: 'My Products',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    sellProducts: 'Sell Products',
    categories: 'Categories',
    
    // Home page categories
    sell: 'Sell',
    store: 'Store',
    adminStore: 'Admin Store',
    animalTrade: 'Animal Trade',
    animalInsurance: 'Animal Insurance',
    mandiRate: 'Mandi Rate',
    post: 'Post',
    weather: 'Weather',
    commoditiesAndFood: 'Commodities and Food',
    FasalBima:'Fasal Bima',
    // Categories
    grains: 'Grains',
    fruits: 'Fruits',
    vegetables: 'Vegetables',
    dairy: 'Dairy',
    livestock: 'Animal',
    spices: 'Spices',
    'organic products': 'Organic Products',
    'seeds & saplings': 'Seeds & Saplings',
    'farm equipment': 'Farm Equipment',
    'fertilizers & pesticides': 'Fertilizers & Pesticides',
    'farming services': 'Farming Services',
    
    // Subcategories
    rice: 'Rice',
    wheat: 'Wheat',
    barley: 'Barley',
    maize: 'Maize',
    millets: 'Millets',
    pulses: 'Pulses',
    'other grains': 'Other Grains',
    mangoes: 'Mangoes',
    bananas: 'Bananas',
    apples: 'Apples',
    oranges: 'Oranges',
    grapes: 'Grapes',
    watermelons: 'Watermelons',
    papayas: 'Papayas',
    'seasonal fruits': 'Seasonal Fruits',
    'other fruits': 'Other Fruits',
    potatoes: 'Potatoes',
    tomatoes: 'Tomatoes',
    onions: 'Onions',
    'leafy greens': 'Leafy Greens',
    gourds: 'Gourds',
    'root vegetables': 'Root Vegetables',
    'seasonal vegetables': 'Seasonal Vegetables',
    'other vegetables': 'Other Vegetables',
    milk: 'Milk',
    ghee: 'Ghee',
    butter: 'Butter',
    paneer: 'Paneer',
    curd: 'Curd',
    buttermilk: 'Buttermilk',
    'other dairy products': 'Other Dairy Products',
    cows: 'Cows',
    buffaloes: 'Buffaloes',
    goats: 'Goats',
    sheep: 'Sheep',
    poultry: 'Poultry',
    'other livestock': 'Other Animals',
    turmeric: 'Turmeric',
    chili: 'Chili',
    coriander: 'Coriander',
    cumin: 'Cumin',
    sellLivestock:'Sell Animals',
    cardamom: 'Cardamom', 
    cloves: 'Cloves',
    'black pepper': 'Black Pepper',
    'other spices': 'Other Spices',
    'organic vegetables': 'Organic Vegetables',
    'organic fruits': 'Organic Fruits',
    'organic grains': 'Organic Grains',
    'organic spices': 'Organic Spices',
    'other organic products': 'Other Organic Products',
    'vegetable seeds': 'Vegetable Seeds',
    'fruit saplings': 'Fruit Saplings',
    'flower seeds': 'Flower Seeds',
    'herb seeds': 'Herb Seeds',
    'other seeds': 'Other Seeds',
    'tractors': 'Tractors',
    'harvesters': 'Harvesters',
    'plows': 'Plows',
    'irrigation equipment': 'Irrigation Equipment',
    'hand tools': 'Hand Tools',
    'other equipment': 'Other Equipment',
    'organic fertilizers': 'Organic Fertilizers',
    'chemical fertilizers': 'Chemical Fertilizers',
    'bio fertilizers': 'Bio Fertilizers',
    'pesticides': 'Pesticides',
    'insecticides': 'Insecticides',
    'other agro chemicals': 'Other Agro Chemicals',
    'tractor rental': 'Tractor Rental',
    'harvesting services': 'Harvesting Services',
    'transportation': 'Transportation',
    'storage facilities': 'Storage Facilities',
    'soil testing': 'Soil Testing',
    'other services': 'Other Services',
    'seasonal fruits': 'Seasonal Fruits',
    'seasonal vegetables': 'Seasonal Vegetables',
    
    // Notifications
    newMessage: 'New message',
    newMessageFrom: 'You have a new message from a buyer',
    priceAlert: 'Price alert',
    priceAlertDesc: 'Rice prices have increased by 5%',
    hoursAgo: 'hours ago',
    yesterday: 'Yesterday',
    loginToView: 'Please login to view notifications',
    
    // Products
    recentlyAddedProducts: 'Recently Added Products',
    freshSeasonalFruits: 'Fresh Seasonal Fruits',
    directlyFromOrchards: 'Directly from orchards across India',
    upTo: 'Up to',
    off: 'Off',
    
    // Examples with interpolation
    welcomeUser: 'Welcome, {{name}}!',
    productCount: 'Found {{count}} products',
    priceRange: 'Price: {{min}} - {{max}}',
    
    // Community
    join: 'Join',
    members: 'Members',
    
    // Not Listed Anything
    nothingListed: 'Nothing Listed',
    nothingListedYet: 'There isn\'t listed anything yet',
    letGoUnused: 'Let go of what you don\'t use anymore',
    goToHome: 'Go to Home',
    
    // Not Found
    pageNotFound: 'Page Not Found',
    pageNotFoundDesc: 'The page you\'re looking for does not seem to exist',
    
    // Search Not Found
    oops: 'Oops!',
    cantFindThat: 'We can\'t seem to find that.',
    trySearchAgain: 'Try searching for it again.',
    
    // Footer
    connectSocial: 'Connect with us on social networks',
    AgroManch: 'Agro Manch',
    footerAboutText: 'Agro Manch is a comprehensive agricultural platform that connects farmers, suppliers, and buyers. We provide a user-friendly marketplace for agricultural products, equipment, and specialized chemicals. Our mission is to empower farmers with technology and create sustainable agricultural communities.',
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    careers: 'Careers',
    contactUs: 'Contact Us',
    sustainability: 'Sustainability',
    partnerWithUs: 'Partner With Us',
    resources: 'Resources',
    helpCenter: 'Help Center',
    sitemap: 'Sitemap',
    privacyPolicy: 'Privacy Policy',
    farmingBlog: 'Farming Blog',
    equipmentMarketplace: 'Equipment Marketplace',
    farmerCommunity: 'Farmer Community',
    contact: 'Contact',
    address: 'Agro Manch Gahna, Mau, Uttar Pradesh',
    email: 'support@agromanch.com',
    phone: '+91 94523 50183',
    copyright: 'Copyright',
    websiteUrl: 'agromanch.com',
    madeWith: 'Made with',
    by: 'by',
    developerName: 'Anuj Kumar',
    
    // Government Schemes
    governmentAgriculturalSchemes: 'Government Agricultural Schemes',
    exploreSchemes: 'Explore various government schemes and benefits available for farmers',
    benefits: 'Benefits',
    eligibility: 'Eligibility',
    applyNow: 'Apply Now',
    source: 'Source',
    lastUpdated: 'Last Updated',
    
    // Agriculture News
    agricultureFarmerNews: 'Agriculture & Farmer News',
    latestAgricultureUpdates: 'Latest updates on farming, crops, and agricultural technologies',
    searchNewsPlaceholder: 'Search for news (e.g., organic farming, crop prices)',
    loadingNews: 'Loading news...',
    failedToFetchNews: 'Failed to fetch news. Please try again later.',
    noNewsFound: 'No news articles found. Try a different search term.',
    readMore: 'Read more',
    
    // Weather Forecast
    locale: 'en-US',
    agriculturalWeatherForecast: 'Agricultural Weather Forecast',
    errorFetchingWeather: 'Error fetching weather data',
    locationAccessDenied: 'Location access denied',
    unableToLoadWeather: 'Unable to load weather data',
    feelsLike: 'Feels like',
    humidity: 'Humidity',
    pressure: 'Pressure',
    wind: 'Wind',
    precipitation: 'Precipitation',
    sunrise: 'Sunrise',
    sunset: 'Sunset',
    
    // Maintenance Page
    serverDown: 'Server is Down',
    maintenanceJoke: 'Why did the website go for free hosting?',
    maintenanceJokePunchline: 'Because it wanted to save up for a domain vacation! 😄',
    maintenanceApology: 'We apologize for the inconvenience.',
    
    // Weather Page
    weatherForecast: 'Weather Forecast',
    generalForecast: 'General Forecast',
    cropSpecific: 'Crop Specific',
    weatherAlerts: 'Weather Alerts',
    cropSpecificRecommendations: 'Crop Specific Recommendations',
    rice: 'Rice',
    wheat: 'Wheat',
    corn: 'Corn',
    vegetables: 'Vegetables',
    fruits: 'Fruits',
    riceCultivationAdvice: 'Rice Cultivation Advice',
    riceTip1: 'Current conditions are suitable for irrigation',
    riceTip2: 'Monitor for pest activity due to high humidity',
    riceTip3: 'Ideal time for fertilizer application',
    wheatCultivationAdvice: 'Wheat Cultivation Advice',
    wheatTip1: 'Moderate watering recommended',
    wheatTip2: 'Watch for fungal diseases due to humidity',
    wheatTip3: 'Good conditions for growth',
    cornCultivationAdvice: 'Corn Cultivation Advice',
    cornTip1: 'Ensure adequate irrigation',
    cornTip2: 'Monitor for corn borer activity',
    cornTip3: 'Apply foliar spray if needed',
    vegetableCultivationAdvice: 'Vegetable Cultivation Advice',
    vegetableTip1: 'Protect leafy vegetables from direct sunlight',
    vegetableTip2: 'Regular watering recommended',
    vegetableTip3: 'Watch for aphid infestation',
    fruitCultivationAdvice: 'Fruit Cultivation Advice',
    fruitTip1: 'Protect fruits from sunburn',
    fruitTip2: 'Maintain consistent watering',
    fruitTip3: 'Monitor for fruit flies',
    moderateRainExpected: 'Moderate Rain Expected',
    moderateRainDescription: 'Light to moderate rainfall expected in the next 48 hours. Plan field activities accordingly.',
    temperatureFluctuation: 'Temperature Fluctuation',
    temperatureFluctuationDescription: 'Temperature variations expected. Protect sensitive crops from sudden changes.',
    

    posts: 'Posts',
    following: 'Following',
    allPosts: 'All Posts',
    followingPosts: 'Following Posts',
    news: 'News',
    
    // Store List
    agriculturalStores: 'Agricultural Stores',
    findLocalStores: 'Find local stores selling fresh agricultural products',
    noStoresFound: 'No stores found matching your criteria.',
    tryAdjustingFilters: 'Try adjusting your filters or adding your own store.',
    addYourStore: 'Add Your Store',
    viewStore: 'View Store',
    kmAway: 'km away',
    
    // Sell Form
    profile: 'Profile',
    yourDetails: 'Your details',
    product: 'Product',
    productDetails: 'Product details',
    price: 'Price',
    setYourPrice: 'Set your price',
    location: 'Location',
    whereToSell: 'Where to sell',
    images: 'Images',
    uploadPhotos: 'Upload photos',
    addMoreImages: 'Add More Images',
    uploadingYourProduct: 'Uploading your product...',
    previous: 'Previous',
    next: 'Next',
    submit: 'Submit',
    

    // Home Page Banners and Sections
    organicVegetables: 'Organic Vegetables',
    chemicalFreeNaturallyGrown: 'Chemical-free and naturally grown',
    freshlyHarvested: 'Freshly Harvested',
    farmFreshDairyProducts: 'Farm Fresh Dairy Products',
    pureMilkDescription: 'Pure milk, ghee, butter and more from Indian cows and buffaloes',
    premiumQuality: 'Premium Quality',
    dairyProducts: 'Dairy Products',
    farmingEquipment: 'Farming Equipment',
    farmingEquipmentDescription: 'Tools, machinery and equipment for modern farming',
    bestDeals: 'Best Deals',
    allProducts: 'All Products',
    loadMore: 'Load More',
    joinAgriculturalRevolution: 'Join the Agricultural Revolution',
    connectWithFarmers: 'Connect with thousands of farmers and buyers across India. Create your account today and start selling your agricultural products directly to consumers.',
    startSellingNow: 'Start Selling Now',
    freshProducts: '100% Fresh Products',
    directFromFarms: 'Direct from farms to your doorstep',
    qualityAssured: 'Quality Assured',
    qualityCheckedProducts: 'All products are quality checked',
    supportFarmers: 'Support Farmers',
    buyDirectlyFromFarmers: 'Buy directly from local farmers',
    fastDelivery: 'Fast Delivery',
    quickReliableShipping: 'Quick and reliable shipping',
    
    // Animal Selling
    howManyDaysToSell: 'How many days to sell in?',
    oneToThreeDays: '1 to 3 days',
    fourToSevenDays: '4 to 7 days',
    moreThanWeek: 'More than a week',
    whatKindOfAnimal: 'What kind of animal do you want to sell?',
    tetheredAnimal: 'Tethered Animal',
    marketAnimal: 'Market Animal',
    uploadVideoOrPhoto: 'Upload video or photo *',
    goodPhotosSellFast: 'Good photos sell quickly',
    chooseVideo: 'Choose video',
    chooseUdderPhoto: 'Choose udder photo',
    uploadMilkingVideo: 'Upload milking video',
    choosePhoto: 'Choose photo',
    additionalInformation: 'Add more information',
    location: 'Location',
    buyersWillSeeAnimal: 'Buyers will see your animal at this location',
    change: 'Change',
    buyersLookingForAnimals: 'buyers are looking for animals',
    register: 'Register',
    animalType: 'Animal Type',
    title: 'Title',
    description: 'Description',
    price: 'Price',
    chooseAnimalType: 'Choose animal type to sell',
    sellFromHereNote: 'You will be taken to the sell form with the chosen livestock type.',
    whichAnimal: 'Which animal',
    whichLactation: 'Which lactation cycle',
    notCalved: 'Not calved',
    first: 'First',
    second: 'Second',
    other: 'Other',
    currentMilkPerDay: 'Current milk (per day)',
    totalMilkToday: 'Total milk of 2 times today',
    milkPlaceholder: 'e.g.: 10',
    liter: 'Liter',
    rate: 'Rate',
    enterCorrectRate: 'Enter the correct rate, more customers call',
    pricePlaceholder: 'e.g.: ₹40,000',
    rupee: 'Rupee',
    checkCorrectRate: 'Know the correct rate of this animal',
    addMoreInfoPlaceholder: 'Add any additional information about the animal',
  },
  hi: {
    // Common
    welcome: 'स्वागत है',
    search: 'खोज',
    searchPlaceholder: 'बीज, उपकरण, उपकरण के लिए खोजें...',
    notifications: 'सूचनाएं',
    settings: 'सेटिंग्स',
    language: 'भाषा',
    english: 'अंग्रेज़ी',
    hindi: 'हिंदी',
    close: 'बंद करें',
    apply: 'लागू करें',
    seeAll: 'सभी देखें',
    pleaseWait: 'कृपया प्रतीक्षा करें...',
    chooseCategory: 'श्रेणी चुनें',
    FasalBima:'फसल बीमा',

    // Livestock Page
    buyLivestock: 'पशु खरीदें',
    animalFeed: 'पशु आहार',
    businessmen:'व्यापारी',
    livestockInsurance: 'पशु बीमा',
    sellLivestock:'पशु बेचें',
    
    // Navigation
    home: 'होम',
    feed: 'एग्रो मीडिया',
    chat: 'चैट',
    socialFeed: 'सोशल फीड',
    profile: 'प्रोफाइल',
    viewEditProfile: 'प्रोफाइल देखें/संपादित करें',
    myProducts: 'मेरे उत्पाद',
    login: 'लॉगिन',
    register: 'रजिस्टर',
    logout: 'लॉगआउट',
    sellProducts: 'उत्पाद बेचें',
    categories: 'श्रेणियाँ',
    
    // Home page categories
    sell: 'बेचें',
    store: 'स्टोर',
    adminStore: 'एडमिन स्टोर',
    animalTrade: 'पशु व्यापार',
    animalInsurance: 'पशु बीमा',
    mandiRate: 'मंडी दर',
    post: 'पोस्ट',
    weather: 'मौसम',
    commoditiesAndFood: 'वस्तुएं और खाद्य पदार्थ',
    
    // Livestock Page
    buyLivestock: 'पशु खरीदें',
    animalFeed: 'पशु आहार',
    livestockInsurance: 'पशु बीमा',
    
    // Social Media
    posts: 'पोस्ट',
    following: 'फॉलोइंग',
    allPosts: 'सभी पोस्ट',
    followingPosts: 'फॉलोइंग पोस्ट',
    news: 'समाचार',
    
    // Store List
    agriculturalStores: 'कृषि स्टोर',
    findLocalStores: 'स्थानीय स्टोर खोजें जो ताजा कृषि उत्पाद बेचते हैं',
    noStoresFound: 'आपके मापदंडों से मेल खाने वाला कोई स्टोर नहीं मिला।',
    tryAdjustingFilters: 'अपने फ़िल्टर समायोजित करें या अपना स्वयं का स्टोर जोड़ें।',
    addYourStore: 'अपना स्टोर जोड़ें',
    viewStore: 'स्टोर देखें',
    kmAway: 'किमी दूर',
    
    // Sell Form
    profile: 'प्रोफाइल',
    yourDetails: 'आपका विवरण',
    product: 'उत्पाद',
    productDetails: 'उत्पाद विवरण',
    price: 'मूल्य',
    setYourPrice: 'अपना मूल्य निर्धारित करें',
    location: 'स्थान',
    whereToSell: 'कहां बेचना है',
    images: 'चित्र',
    uploadPhotos: 'फोटो अपलोड करें',
    addMoreImages: 'अधिक चित्र जोड़ें',
    uploadingYourProduct: 'आपका उत्पाद अपलोड हो रहा है...',
    previous: 'पिछला',
    next: 'अगला',
    submit: 'जमा करें',
    
    // Categories
    grains: 'अनाज',
    fruits: 'फल',
    vegetables: 'सब्जियां',
    dairy: 'डेयरी',
    livestock: 'पशु',
    spices: 'मसाले',
    'organic products': 'जैविक उत्पाद',
    'seeds & saplings': 'बीज और पौधे',
    'farm equipment': 'कृषि उपकरण',
    'fertilizers & pesticides': 'उर्वरक और कीटनाशक',
    'farming services': 'कृषि सेवाएं',
    
    // Subcategories
    rice: 'चावल',
    wheat: 'गेहूं',
    barley: 'जौ',
    maize: 'मक्का',
    millets: 'बाजरा',
    pulses: 'दालें',
    'other grains': 'अन्य अनाज',
    mangoes: 'आम',
    bananas: 'केले',
    apples: 'सेब',
    oranges: 'संतरे',
    grapes: 'अंगूर',
    watermelons: 'तरबूज',
    papayas: 'पपीता',
    'seasonal fruits': 'मौसमी फल',
    'other fruits': 'अन्य फल',
    potatoes: 'आलू',
    tomatoes: 'टमाटर',
    onions: 'प्याज',
    'leafy greens': 'पत्तेदार सब्जियां',
    gourds: 'कद्दू',
    'root vegetables': 'जड़ वाली सब्जियां',
    'seasonal vegetables': 'मौसमी सब्जियां',
    'other vegetables': 'अन्य सब्जियां',
    milk: 'दूध',
    ghee: 'घी',
    butter: 'मक्खन',
    paneer: 'पनीर',
    curd: 'दही',
    buttermilk: 'छाछ',
    'other dairy products': 'अन्य डेयरी उत्पाद',
    cows: 'गाय',
    buffaloes: 'भैंस',
    goats: 'बकरी',
    sheep: 'भेड़',
    poultry: 'मुर्गी पालन',
    'other livestock': 'अन्य पशु',
    turmeric: 'हल्दी',
    chili: 'मिर्च',
    coriander: 'धनिया',
    cumin: 'जीरा',
    cardamom: 'इलायची',
    cloves: 'लौंग',
    'black pepper': 'काली मिर्च',
    'other spices': 'अन्य मसाले',
    'organic vegetables': 'जैविक सब्जियां',
    'organic fruits': 'जैविक फल',
    'organic grains': 'जैविक अनाज',
    'organic spices': 'जैविक मसाले',
    'other organic products': 'अन्य जैविक उत्पाद',
    'vegetable seeds': 'सब्जी के बीज',
    'fruit saplings': 'फल के पौधे',
    'flower seeds': 'फूल के बीज',
    'herb seeds': 'जड़ी-बूटी के बीज',
    'other seeds': 'अन्य बीज',
    'tractors': 'ट्रैक्टर',
    'harvesters': 'हार्वेस्टर',
    'plows': 'हल',
    'irrigation equipment': 'सिंचाई उपकरण',
    'hand tools': 'हाथ के औजार',
    'other equipment': 'अन्य उपकरण',
    'organic fertilizers': 'जैविक उर्वरक',
    'chemical fertilizers': 'रासायनिक उर्वरक',
    'bio fertilizers': 'जैव उर्वरक',
    'pesticides': 'कीटनाशक',
    'insecticides': 'कीटनाशक',
    'other agro chemicals': 'अन्य कृषि रसायन',
    'tractor rental': 'ट्रैक्टर किराया',
    'harvesting services': 'कटाई सेवाएं',
    'transportation': 'परिवहन',
    'storage facilities': 'भंडारण सुविधाएं',
    'soil testing': 'मिट्टी परीक्षण',
    'other services': 'अन्य सेवाएं',
    'seasonal fruits': 'मौसमी फल',
    'seasonal vegetables': 'मौसमी सब्जियां',
    
    // Notifications
    newMessage: 'नया संदेश',
    newMessageFrom: 'आपको एक खरीदार से नया संदेश मिला है',
    priceAlert: 'मूल्य अलर्ट',
    priceAlertDesc: 'चावल की कीमतों में 5% की वृद्धि हुई है',
    hoursAgo: 'घंटे पहले',
    yesterday: 'कल',
    loginToView: 'सूचनाएं देखने के लिए कृपया लॉगिन करें',
    
    // Products
    recentlyAddedProducts: 'हाल ही में जोड़े गए उत्पाद',
    freshSeasonalFruits: 'ताजे मौसमी फल',
    directlyFromOrchards: 'सीधे भारत भर के बागों से',
    upTo: 'तक',
    off: 'छूट',
    
    // Examples with interpolation
    welcomeUser: 'स्वागत है, {{name}}!',
    productCount: '{{count}} उत्पाद मिले',
    priceRange: 'मूल्य: {{min}} - {{max}}',
    
    // Community
    join: 'शामिल हों',
    members: 'सदस्य',
    
    // Not Listed Anything
    nothingListed: 'कुछ भी सूचीबद्ध नहीं',
    nothingListedYet: 'अभी तक कुछ भी सूचीबद्ध नहीं है',
    letGoUnused: 'जो आप अब उपयोग नहीं करते हैं उसे छोड़ दें',
    goToHome: 'होम पेज पर जाएं',
    
    // Not Found
    pageNotFound: 'पेज नहीं मिला',
    pageNotFoundDesc: 'आप जिस पेज को खोज रहे हैं वह मौजूद नहीं है',
    
    // Search Not Found
    oops: 'उफ़!',
    cantFindThat: 'हम वह नहीं ढूंढ पा रहे हैं।',
    trySearchAgain: 'इसे फिर से खोजने का प्रयास करें।',
    
    // Footer
    connectSocial: 'सोशल नेटवर्क पर हमसे जुड़ें',
    AgroManch: 'एग्रो मंच',
    footerAboutText: 'एग्रो मंच एक व्यापक कृषि मंच है जो किसानों, आपूर्तिकर्ताओं और खरीदारों को जोड़ता है। हम कृषि उत्पादों, उपकरणों और विशेष रसायनों के लिए एक उपयोगकर्ता-अनुकूल बाज़ार प्रदान करते हैं। हमारा मिशन किसानों को प्रौद्योगिकी के साथ सशक्त बनाना और टिकाऊ कृषि समुदायों का निर्माण करना है।',
    aboutUs: 'हमारे बारे में',
    ourStory: 'हमारी कहानी',
    careers: 'करियर',
    contactUs: 'संपर्क करें',
    sustainability: 'स्थिरता',
    partnerWithUs: 'हमारे साथ भागीदारी करें',
    resources: 'संसाधन',
    helpCenter: 'सहायता केंद्र',
    sitemap: 'साइटमैप',
    privacyPolicy: 'गोपनीयता नीति',
    farmingBlog: 'खेती ब्लॉग',
    equipmentMarketplace: 'उपकरण बाज़ार',
    farmerCommunity: 'किसान समुदाय',
    contact: 'संपर्क',
    address: 'एग्रो मंच गहना, मऊ, उत्तर प्रदेश',
    email: 'support@agromanch.com',
    phone: '+91 94523 50183',
    copyright: 'कॉपीराइट',
    websiteUrl: 'AgroManch.com',
    madeWith: 'बनाया गया',
    by: 'द्वारा',
    developerName: 'अनुज कुमार',
    
    // Government Schemes
    governmentAgriculturalSchemes: 'सरकारी कृषि योजनाएं',
    exploreSchemes: 'किसानों के लिए उपलब्ध विभिन्न सरकारी योजनाओं और लाभों का पता लगाएं',
    benefits: 'लाभ',
    eligibility: 'पात्रता',
    applyNow: 'अभी आवेदन करें',
    source: 'स्रोत',
    lastUpdated: 'अंतिम अपडेट',
    
    // Agriculture News
    agricultureFarmerNews: 'कृषि और किसान समाचार',
    latestAgricultureUpdates: 'खेती, फसलों और कृषि प्रौद्योगिकियों पर नवीनतम अपडेट',
    searchNewsPlaceholder: 'समाचार खोजें (जैसे, जैविक खेती, फसल की कीमतें)',
    loadingNews: 'समाचार लोड हो रहा है...',
    failedToFetchNews: 'समाचार प्राप्त करने में विफल। कृपया बाद में पुनः प्रयास करें।',
    noNewsFound: 'कोई समाचार लेख नहीं मिला। एक अलग खोज शब्द का प्रयास करें।',
    readMore: 'और पढ़ें',
    
    // Weather Forecast
    locale: 'hi-IN',
    agriculturalWeatherForecast: 'कृषि मौसम पूर्वानुमान',
    errorFetchingWeather: 'मौसम डेटा प्राप्त करने में त्रुटि',
    locationAccessDenied: 'स्थान तक पहुंच अस्वीकृत',
    unableToLoadWeather: 'मौसम डेटा लोड करने में असमर्थ',
    feelsLike: 'अनुभव होता है',
    humidity: 'आर्द्रता',
    pressure: 'दबाव',
    wind: 'हवा',
    precipitation: 'वर्षा',
    sunrise: 'सूर्योदय',
    sunset: 'सूर्यास्त',
    
    // Maintenance Page
    serverDown: 'सर्वर डाउन है',
    maintenanceJoke: 'वेबसाइट मुफ्त होस्टिंग के लिए क्यों गई?',
    maintenanceJokePunchline: 'क्योंकि यह डोमेन की छुट्टी के लिए बचत करना चाहती थी! 😄',
    maintenanceApology: 'असुविधा के लिए हमें खेद है।',
    
    // Weather Page
    weatherForecast: 'मौसम पूर्वानुमान',
    generalForecast: 'सामान्य पूर्वानुमान',
    cropSpecific: 'फसल विशिष्ट',
    weatherAlerts: 'मौसम अलर्ट',
    cropSpecificRecommendations: 'फसल विशिष्ट सिफारिशें',
    rice: 'चावल',
    wheat: 'गेहूं',
    corn: 'मक्का',
    vegetables: 'सब्जियां',
    fruits: 'फल',
    riceCultivationAdvice: 'चावल की खेती की सलाह',
    riceTip1: 'वर्तमान स्थितियां सिंचाई के लिए उपयुक्त हैं',
    riceTip2: 'उच्च आर्द्रता के कारण कीट गतिविधि की निगरानी करें',
    riceTip3: 'उर्वरक अनुप्रयोग के लिए आदर्श समय',
    wheatCultivationAdvice: 'गेहूं की खेती की सलाह',
    wheatTip1: 'मध्यम सिंचाई की सिफारिश की जाती है',
    wheatTip2: 'आर्द्रता के कारण फफूंदी रोगों पर नज़र रखें',
    wheatTip3: 'विकास के लिए अच्छी स्थितियां',
    cornCultivationAdvice: 'मक्का की खेती की सलाह',
    cornTip1: 'पर्याप्त सिंचाई सुनिश्चित करें',
    cornTip2: 'मक्का बोरर गतिविधि की निगरानी करें',
    cornTip3: 'यदि आवश्यक हो तो फोलियर स्प्रे लगाएं',
    vegetableCultivationAdvice: 'सब्जी की खेती की सलाह',
    vegetableTip1: 'पत्तेदार सब्जियों को सीधी धूप से बचाएं',
    vegetableTip2: 'नियमित सिंचाई की सिफारिश की जाती है',
    vegetableTip3: 'एफिड संक्रमण पर नज़र रखें',
    fruitCultivationAdvice: 'फल की खेती की सलाह',
    fruitTip1: 'फलों को धूप से जलने से बचाएं',
    fruitTip2: 'लगातार सिंचाई बनाए रखें',
    fruitTip3: 'फल मक्खियों की निगरानी करें',
    moderateRainExpected: 'मध्यम वर्षा की उम्मीद',
    moderateRainDescription: 'अगले 48 घंटों में हल्की से मध्यम वर्षा की उम्मीद है। तदनुसार खेत की गतिविधियों की योजना बनाएं।',
    temperatureFluctuation: 'तापमान में उतार-चढ़ाव',
    temperatureFluctuationDescription: 'तापमान में बदलाव की उम्मीद है। संवेदनशील फसलों को अचानक परिवर्तन से बचाएं।',
    
    // Home Page Banners and Sections
    organicVegetables: 'जैविक सब्जियां',
    chemicalFreeNaturallyGrown: 'रसायन मुक्त और प्राकृतिक रूप से उगाया गया',
    freshlyHarvested: 'ताजा कटाई',
    farmFreshDairyProducts: 'खेत से ताजा डेयरी उत्पाद',
    pureMilkDescription: 'भारतीय गायों और भैंसों से शुद्ध दूध, घी, मक्खन और अधिक',
    premiumQuality: 'प्रीमियम गुणवत्ता',
    dairyProducts: 'डेयरी उत्पाद',
    farmingEquipment: 'कृषि उपकरण',
    farmingEquipmentDescription: 'आधुनिक खेती के लिए उपकरण, मशीनरी और उपकरण',
    bestDeals: 'सर्वोत्तम सौदे',
    allProducts: 'सभी उत्पाद',
    loadMore: 'और लोड करें',
    joinAgriculturalRevolution: 'कृषि क्रांति में शामिल हों',
    connectWithFarmers: 'भारत भर में हजारों किसानों और खरीदारों से जुड़ें। आज ही अपना खाता बनाएं और अपने कृषि उत्पादों को सीधे उपभोक्ताओं को बेचना शुरू करें।',
    startSellingNow: 'अभी बेचना शुरू करें',
    freshProducts: '100% ताजा उत्पाद',
    directFromFarms: 'खेतों से सीधे आपके द्वार तक',
    qualityAssured: 'गुणवत्ता आश्वासन',
    qualityCheckedProducts: 'सभी उत्पादों की गुणवत्ता जांची जाती है',
    supportFarmers: 'किसानों का समर्थन करें',
    buyDirectlyFromFarmers: 'स्थानीय किसानों से सीधे खरीदें',
    fastDelivery: 'तेज़ डिलीवरी',
    quickReliableShipping: 'त्वरित और विश्वसनीय शिपिंग',
    
    // Animal Selling
    howManyDaysToSell: 'कितने दिन में बेचना है',
    oneToThreeDays: '1 से 3 दिन',
    fourToSevenDays: '4 से 7 दिन',
    moreThanWeek: 'हफ़्ते से ज़्यादा',
    whatKindOfAnimal: 'कैसा पशु बेचना चाहते हो ?',
    tetheredAnimal: 'खूंटे का पशु',
    marketAnimal: 'मंडी का पशु',
    uploadVideoOrPhoto: 'वीडियो या फोटो डालें *',
    goodPhotosSellFast: 'अच्छी फोटो डालने पर जल्दी बिकती है',
    chooseVideo: 'वीडियो चुनें',
    chooseUdderPhoto: 'थन का फोटो चुनें',
    uploadMilkingVideo: 'दूध दुहाई का वीडियो डालें',
    choosePhoto: 'फोटो चुनें',
    additionalInformation: 'और जानकारी डालें',
    location: 'जगह',
    buyersWillSeeAnimal: 'ख़रीदारो को आपका पशु इस जगह दिखेगा',
    change: 'बदलें',
    buyersLookingForAnimals: 'ख़रीददार पशु ढूँढ रहे हैं',
    register: 'दर्ज करें',
    animalType: 'पशु का प्रकार',
    title: 'शीर्षक',
    description: 'विवरण',
    price: 'मूल्य',
    chooseAnimalType: 'बेचने के लिए पशु का प्रकार चुनें',
    sellFromHereNote: 'आपको चुने गए पशुधन प्रकार के साथ बिक्री फॉर्म पर ले जाया जाएगा।',
    whichAnimal: 'कौन सा पशु',
    whichLactation: 'कौन सा ब्यात',
    notCalved: 'ब्यायी नहीं',
    first: 'पहला',
    second: 'दूसरा',
    other: 'अन्य',
    currentMilkPerDay: 'अभी का दूध (प्रति-दिन)',
    totalMilkToday: 'आज का 2 समय का कुल दूध',
    milkPlaceholder: 'जैसे: 10',
    liter: 'लीटर',
    rate: 'रेट',
    enterCorrectRate: 'सही रेट डालें, उससे ज़्यादा ग्राहक कॉल करते हैं',
    pricePlaceholder: 'जैसे: ₹40,000',
    rupee: 'रुपए',
    checkCorrectRate: 'इस पशु का सही रेट जानें',
    addMoreInfoPlaceholder: 'पशु के बारे में कोई अतिरिक्त जानकारी जोड़ें',
  }
};

export default translations;